import DescriptionStrategy from './DescriptionStrategy'
import messageResource from '../../../../messageResource'
import {AccessRights} from 'constants'
import {Feature} from '../../../../features/constants'

export default class BillingSummaryDescriptionStrategy extends DescriptionStrategy {
    constructor({
        reportUrl = '',
        name = '',
    }) {
        super()

        this.params = {
            reportUrl,
            name,
        }

        this.state = {
            userInDar: false,
            enabledFeatures: {},
            userRights: {},
        }

        this.userType = null

        this.onStatePropertyChanged('userRights', (userRights) => {
            if (userRights[AccessRights.GENERATE_MONEY_REPORTS])
                this.userType = UserTypes.MANAGE_BILLING_REPORT
            else
                this.userType = UserTypes.REGULAR

        })
    }

    getHeader() {
        return messageResource.getMessage(this.params.name) + ' ' + messageResource.getMessage('report.common.report')
    }

    getDescription() {
        const BRAEnabled = this.state.enabledFeatures[Feature.BRA]
        let firstParagraph
        let secondParagraph
        switch (this.userType) {
            case UserTypes.MANAGE_BILLING_REPORT:
                firstParagraph = BRAEnabled ?
                                 messageResource.getEscapedMessage('dashboard.description.billing_summary.user_with_right.part1') :
                                 messageResource.getEscapedMessage('dashboard.description.billing_summary.user_with_right.part1.without_feature')
                secondParagraph = BRAEnabled ?
                                  messageResource.getEscapedMessage('dashboard.description.billing_summary.user_with_right.part2') :
                                  messageResource.getEscapedMessage('dashboard.description.billing_summary.user_with_right.part2.without_feature')
                return this._createDescription(firstParagraph, secondParagraph)
            case UserTypes.REGULAR:
                return ''
        }
    }

    _createDescription(first, second) {
        return '<div>' +
               '  <div class="firstParagraph billingDescriptionColor">' + first + '</div>' +
               '  <div class="secondParagraph">' + second + '</div>' +
               '</div>'
    }

    getDetailsCallback() {
        openUserGuidePage('report-billing-summary')
    }

    getGenerateCallback() {
        window.location.href = this.params.reportUrl
    }
}

const UserTypes = {
    REGULAR: 'RegularUser',
    MANAGE_BILLING_REPORT: 'ManageBillingReport',
}


// WEBPACK FOOTER //
// ./web/js/reports/dashboard/createReportPopup/components/BillingSummaryDescriptionStrategy.js